import { call, put, takeLatest } from "redux-saga/effects";
import {
  createVoucherCodeFailure,
  createVoucherCodeStart,
  createVoucherCodeSuccess,
  getVoucherCodesFailure,
  getVoucherCodesStart,
  getVoucherCodesSuccess,
  updateVoucherCodeFailure,
  updateVoucherCodeStart,
  updateVoucherCodeSuccess,
  updateVoucherCodeOptimistic,
  deleteVoucherCodeStart,
  deleteVoucherCodeSuccess,
  deleteVoucherCodeFailure,
} from "../redux-slices/voucherCodesSlice";
import { getAllVoucherCodes, createVoucherCode, updateVoucherCode, deleteVoucherCode } from "../../utils/apiCalls";
import { toast } from "../../components/Toast";

export default function* voucherCodesWatcher() {
  yield takeLatest(getVoucherCodesStart.type, getVoucherCodesWorker);
  yield takeLatest(createVoucherCodeStart.type, createVoucherCodeWorker);
  yield takeLatest(updateVoucherCodeStart.type, updateVoucherCodeWorker);
  yield takeLatest(deleteVoucherCodeStart.type, deleteVoucherCodeWorker);
}

function* getVoucherCodesWorker(action) {
  try {
    const { limit, pageNo } = action && action.payload;
    const response = yield getAllVoucherCodes({ limit, pageNo });

    yield put(getVoucherCodesSuccess(response?.data?.data));
  } catch (error) {
    yield toast(error?.response?.data?.errors[0]?.description || "Failed to fetch voucher codes", "error");
    yield put(
      getVoucherCodesFailure(
        error?.response?.data?.errors[0]?.description
      )
    );
  }
}

function* createVoucherCodeWorker(action) {
  try {
    const { data, onSuccess } = action && action.payload;

    yield createVoucherCode(data);

    yield put(createVoucherCodeSuccess());

    yield toast("Voucher code created successfully", "success");

    if (onSuccess && typeof onSuccess === 'function') {
      yield call(onSuccess);
    }
  } catch (error) {
    yield toast(error?.response?.data?.errors?.message || "Failed to create voucher code", "error");
    yield put(createVoucherCodeFailure(error?.response?.data?.errors?.message));
  }
}

function* updateVoucherCodeWorker(action) {
  try {
    const { data, onSuccess, optimisticUpdate } = action && action.payload;

    // Apply optimistic update if requested (status and/or redeemed)
    if (optimisticUpdate) {
      yield put(
        updateVoucherCodeOptimistic({
          voucherCodeId: data.voucherCodeId,
          newStatus: data.status,
          newIsRedeemed: typeof data.isRedeemed !== "undefined" ? data.isRedeemed : undefined,
        })
      );
    }

    const response = yield updateVoucherCode(data);

    yield put(updateVoucherCodeSuccess(response?.data?.data));

    if (!optimisticUpdate) {
      yield toast("Voucher code updated successfully", "success");
    } else {
      yield toast("Voucher code status updated successfully", "success");
    }

    if (onSuccess && typeof onSuccess === 'function') {
      yield call(onSuccess);
    }
  } catch (error) {
    yield toast(error?.response?.data?.errors[0]?.description || "Failed to update voucher code", "error");

    const { data, previousStatus, previousIsRedeemed } = action.payload;
    yield put(
      updateVoucherCodeFailure({
        error: error?.response?.data?.errors[0]?.description,
        voucherCodeId: data.voucherCodeId,
        previousStatus,
        previousIsRedeemed,
      })
    );
  }
}

function* deleteVoucherCodeWorker(action) {
  try {
    const { voucherCodeId, onSuccess } = action?.payload || {};
    const response = yield call(deleteVoucherCode, { voucherCodeId });

    if (response?.status === 200) {
      yield put(deleteVoucherCodeSuccess());
      yield toast("Voucher code deleted successfully", "success");
      if (onSuccess && typeof onSuccess === "function") {
        yield call(onSuccess);
      }
    } else {
      yield toast(response?.data?.errors?.[0]?.description || "Failed to delete voucher code", "error");
      yield put(deleteVoucherCodeFailure(response?.data?.errors?.[0]?.description));
    }
  } catch (error) {
    yield toast(error?.response?.data?.errors?.[0]?.description || "Failed to delete voucher code", "error");
    yield put(deleteVoucherCodeFailure(error?.response?.data?.errors?.[0]?.description));
  }
}
